import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rp-services-section',
  templateUrl: './services-section.component.html',
  styleUrls: ['./services-section.component.scss'],
})
export class ServicesSectionComponent {
  services = [
    {
      badgeIcon: 'svg:ai-camera',
      badgeKey: 'recruiterProgram.services.videoInterviews.badge',
      titleKey: 'recruiterProgram.services.videoInterviews.title',
      descKey: 'recruiterProgram.services.videoInterviews.description',
      imageName: 'service-1',
    },
    {
      badgeIcon: 'svg:ai-search',
      badgeKey: 'recruiterProgram.services.cvScreening.badge',
      titleKey: 'recruiterProgram.services.cvScreening.title',
      descKey: 'recruiterProgram.services.cvScreening.description',
      imageName: 'service-2',
    },
    {
      badgeIcon: 'svg:ai-search',
      badgeKey: 'recruiterProgram.services.jobPostings.badge',
      titleKey: 'recruiterProgram.services.jobPostings.title',
      descKey: 'recruiterProgram.services.jobPostings.description',
      imageName: 'service-3',
    },
  ];

  getSignupUrl(): string {
    const subdomain = environment.server === 'dev' ? 'dev' : 'app';
    return `https://${subdomain}.uptal.com/register?type=recruiter-program`;
  }
}
